<template>
  <div class="social-media-display">
    <div class="dotted-bg"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-3 col-sm-6">
          <a href="#">
            <div class="photo-box" id="facebook1" :style="{backgroundImage: oneBox}">
              <div class="text-overlay">
                <i class="fa fa-facebook" aria-hidden="true"></i>
              </div>
            </div>
          </a>
        </div>
        <div class="col-md-3 col-sm-6">
          <a href="#">
            <div class="photo-box" id="facebook2" :style="{backgroundImage: twoBox}">
              <div class="text-overlay">
                <i class="fa fa-facebook" aria-hidden="true"></i>
              </div>
            </div>
          </a>
        </div>
        <div class="col-md-3 col-sm-6">
          <a href="">
            <div class="photo-box" id="facebook3" :style="{backgroundImage: threeBox}">
              <div class="text-overlay">
                <i class="fa fa-facebook" aria-hidden="true"></i>
              </div>
            </div>
          </a>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="photo-box" id="social-info">
            <h2>Stay Up To Speed</h2>
            <p>
              Keep up with the best at Auto Dealer. Follow us across your social networks to get perspective on our latest deals and news.
            </p>
            <p><strong>FOLLOW US</strong></p>
            <span id="facebook-link"><a href="#"><i class="fa fa-facebook" aria-hidden="true"></i></a></span>
            <span id="youtube-link"><a href="#"><i class="fa fa-youtube" aria-hidden="true"></i></a></span>
            <span id="instagram-link"><a href="#"><i class="fa fa-instagram" aria-hidden="true"></i></a></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      oneBox: 'url(' + this.images.lifestyleImages.sedanImage + ')',
      twoBox: 'url(' + this.images.lifestyleImages.suvImage + ')',
      threeBox: 'url(' + this.images.lifestyleImages.truckImage + ')'
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    }
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .social-media-display {
    background: #fff;
    font-size: 16px;
    padding: 40px 0;
    position: relative;
  }
  .social-media-display .photo-box {
    position: relative;
    width: 100%;
    min-height: 300px;
    box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.3);
    margin-bottom: 20px;
  }
  .social-media-display #facebook1 {
    background-size: cover;
    background-position-x: 85%;
  }
  .social-media-display #facebook2 {
    background-size: cover;
    background-position: center;
  }
  .social-media-display #facebook3 {
    background-size: cover;
    background-position: center;
    background-position-x: 37%;
  }
  .social-media-display #social-info {
    padding: 20px;
    background: #fff;
  }
  .social-media-display #social-info h2 {
    margin-top: 0;
  }
  .social-media-display .text-overlay {
    position: absolute;
    top: 15px;
    right: 15px;
  }
  .social-media-display .text-overlay i {
    color: #fff;
    font-size: 20px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .social-media-display #social-info a {
    color: var(--primary-dark);
    font-size: 20px;
    margin-right: 15px;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .social-media-display #social-info a:hover,
  .social-media-display #facebook1:hover i,
  .social-media-display #facebook2:hover i,
  .social-media-display #facebook3:hover i {
    color: var(--primary-color);
    text-decoration: none;
  }

  @media (min-width: 992px) {
    .social-media-display {
      padding: 100px 15px;
    }
    .social-media-display #facebook1 {
      transform: translate(0, -18%);
    }
    .social-media-display #facebook3 {
      transform: translate(0, 18%);
    }
    .social-media-display .dotted-bg {
      position: absolute;
      top: 100px;
      left: 0px;
      right: 0px;
      height: 250px;
      opacity: 0.3;
      background-image: url(../../static/images/social-media-display-bg.png);
      background-size: 100%;
      background-position: center;
      background-repeat: no-repeat;
    }
  }

  @media (min-width: 1400px) {
    .social-media-display .dotted-bg {
      background-size: 90%, 100%;
    }
  }

  @media (max-width: 767px) {
    .social-media-display .dotted-bg {
      display: none;
    }
  }

  @media (max-width: 1200px) and (min-width: 992px) {
    .social-media-display #social-info {
      min-height: 330px;
    }
  }
</style>